import {Component, EventEmitter, OnInit, Input, Output} from '@angular/core';
import { CollegeType, ElectionColleges, LineupOptions } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-one-college-verification',
  templateUrl: './college-verification.component.html',
  styleUrls: ['./college-verification.component.less', '../../../../shared/common.less']
})
export class OneCollegeVerificationComponent implements OnInit {
  @Input() college: ElectionColleges;
  @Output() collegeChange = new EventEmitter<ElectionColleges>();
  totalColleges: number = 1;
  sirets: string[] = [''];
  collegeTypeOptions = Object.values(CollegeType);
  lineupOptions = LineupOptions;
  hasCourtDecision: boolean = false;

  constructor() { }

  onCollegesChange() {
    this.collegeChange.emit(this.college);
  }

  isCompositionSelected(option: LineupOptions): boolean {
    return this.college.composition && this.college.composition.includes(option);
  }

  toggleComposition(option: LineupOptions): void {
    if (!this.college.composition) {
      this.college.composition = [];
    }
    const index = this.college.composition.indexOf(option);
    if (index > -1) {
      this.college.composition.splice(index, 1);
    } else {
      this.college.composition.push(option);
    }
    this.onCollegesChange();
  }

  get calculatedMenCount(): number {
    const total = Number(this.college.lineup) || 0;
    const women = Number(this.college.genderDistribution[0]) || 0;
    const men = total - women;
    this.college.genderDistribution[1] = men >= 0 ? men : 0;
    return this.college.genderDistribution[1];
  }

  get hasGenderError(): boolean {
    const total = Number(this.college.lineup) || 0;
    const women = Number(this.college.genderDistribution[0]) || 0;
    return women > total;
  }

  get womenPercentage(): number {
    const total = Number(this.college.lineup) || 0;
    const women = Number(this.college.genderDistribution[0]) || 0;
    if (total === 0) return 0;
    return Math.round((women / total) * 100 * 100) / 100;
  }

  get menPercentage(): number {
    const total = Number(this.college.lineup) || 0;
    const men = this.calculatedMenCount;
    if (total === 0) return 0;
    return Math.round((men / total) * 100 * 100) / 100;
  }

  get maxDate(): string {
    return new Date().toISOString().substring(0, 10);
  }

  get courtDecisionText(): boolean {
    if (!this.college.cancelledElection) {
      return false;
    }
    const cancelledDate = new Date(this.college.cancelledElection);
    const today = new Date();
    cancelledDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return cancelledDate.getTime() === today.getTime() ? false : true;
  }

  get womenSeatsCount(): number {
    const womenSeatsCount = Math.round(this.college.seats * (this.womenPercentage / 100));
    this.college.proportion[0] = womenSeatsCount;
    return womenSeatsCount;
  }

  get menSeatsCount(): number {
    const menSeatsCount = Math.round(this.college.seats * (this.menPercentage / 100));
    this.college.proportion[1] = menSeatsCount;
    return menSeatsCount;
  }

  get womenSubstituteSeatsCount(): number {
    const womenSubstituteSeatsCount = Math.round(this.college.substituteSeats * (this.womenPercentage / 100));
    this.college.substituteProportion[0] = womenSubstituteSeatsCount;
    return womenSubstituteSeatsCount;
  }

  get menSubstituteSeatsCount(): number {
    const menSubstituteSeatsCount = Math.round(this.college.substituteSeats * (this.menPercentage / 100));
    this.college.substituteProportion[1] = menSubstituteSeatsCount;
    return menSubstituteSeatsCount;
  }

  onlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
    
  }

  trackByIndex(index: number): number {
    return index;
  }

  ngOnInit(): void {
    if (!this.college.collegeType[0]) {
      this.college.collegeType[0] = this.collegeTypeOptions[0];
    }
  }

}
